







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IDelegate } from "@/interfaces";

@Component
export default class TableDelegatesMobile extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public delegates: IDelegate[] | null;
}
